import React from 'react';
import { combineValidators, isRequired } from 'revalidate';
import { reduxForm, Field } from 'redux-form';
import LoginTextInput from '../common/form/LoginTextInput';
import LoginIcon from '../common/icons/LoginIcon';

const validate = combineValidators({
  username: isRequired({ message: 'Username is required' }),
  password: isRequired({ message: 'Password is required' }),
});

function LoginForm({ initialValues, handleSubmit, onLogin, error, loading }) {

  return (
    <form onSubmit={handleSubmit(onLogin)} autoComplete='off'>
      <Field
        name='username'
        type='text'
        component={LoginTextInput}
        placeholder='Username'
        defaultValue={initialValues?.username}
        autoComplete='new-password'
        label='Username'
        icon='account'
      />
      <Field
        name='password'
        type='password'
        autoComplete='new-password'
        component={LoginTextInput}
        placeholder='Password'
        defaultValue={initialValues?.password}
        label='Password'
        icon='lock'
      />
      <div className='field has-text-centered' style={{ marginTop: 25 }}>
        {error && <p className='help is-danger'>{error}</p>}
        <button
          disabled={loading}
          type='submit'
          style={{ marginRight: 10 }}
          className={`button is-info is-small is-rounded${
            loading ? ' is-loading' : ''
          }`}
        >
          <span className='mr-1 mt-1 flex justify-start align-center'>
            {!loading && <LoginIcon size={15} color={'#ffffff'} />}
            <span className='ml-1'>Login</span>
          </span>
        </button>
      </div>
    </form>
  );
}

export default reduxForm({ form: 'formLogin', validate })(LoginForm);
